export const GET_PETITIONS_REQUEST = 'GET_DASHBOARD_PETITIONS_REQUEST';
export const GET_PETITIONS_SUCCESS = 'GET_DASHBOARD_PETITIONS_SUCCESS';
export const GET_PETITIONS_FAILED = 'GET_DASHBOARD_PETITIONS_FAILED';
export const GET_DASHBOARD_TEAMS_REQUEST = 'GET_DASHBOARD_TEAMS_REQUEST';
export const GET_DASHBOARD_TEAMS_SUCCESS = 'GET_DASHBOARD_TEAMS_SUCCESS';
export const GET_DASHBOARD_TEAMS_FAILED = 'GET_DASHBOARD_TEAMS_FAILED';
export const SET_DASHBOARD_VIEW_BY = 'SET_DASHBOARD_VIEW_BY';
